import { Container, Grid, Typography, Box, Button } from '@mui/material';
import { getImageUrl } from '../../utils';

const personalTrainingImages = [
  getImageUrl('pt-sandra.png'),
  getImageUrl('pt-3.png'),
  getImageUrl('pt-1.png')
];

const PersonalTrainingInfo = () => (
  <Container sx={{ py: { xs: 6, md: 8 } }}>
    {/* Title */}
    <Typography
      variant="h3"
      align="center"
      sx={{
        fontWeight: 'bold',
        color: '#007C85',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        mb: 3,
        fontSize: { xs: '2rem', md: '2.75rem' }
      }}
    >
      Personlig Träning
    </Typography>

    {/* Description */}
    <Typography
      variant="body1"
      sx={{
        maxWidth: '750px',
        mx: 'auto',
        textAlign: 'center',
        color: '#555',
        fontSize: { xs: '1rem', md: '1.125rem' },
        lineHeight: 1.8,
        mb: 4
      }}
    >
      Upptäck fördelarna med personlig träning – skräddarsydd för dina behov. Våra certifierade tränare
      guidar dig tryggt och effektivt, oavsett nivå.
    </Typography>

    {/* Call to Action */}
    <Box sx={{ textAlign: 'center', mb: 6 }}>
      <Button
        variant="contained"
        href="https://pilateshoganas.wondr.se/w_booking/wizards/book/600833b3-4b08-4acb-9202-001c0a1000ef"
        sx={{
          background: 'linear-gradient(135deg, #00b5bf, #429398)',
          color: '#fff',
          px: 4,
          py: 1.5,
          fontSize: '1rem',
          fontWeight: 600,
          borderRadius: '30px',
          textTransform: 'none',
          boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
           '&:hover': {
                      transform: 'translateY(-2px)',
                      background: 'linear-gradient(135deg, #007C85, #357f87)',
                    },
        }}
      >
        Boka Personlig Träning
      </Button>
    </Box>

    {/* Image Grid */}
    <Grid container spacing={4} justifyContent="center">
      {personalTrainingImages.map((image, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Box
            sx={{
              height: { xs: '300px', md: '400px' },
              borderRadius: '16px',
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              boxShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
              '&:hover': {
                transform: 'scale(1.03)',
                boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
              },
            }}
          />
        </Grid>
      ))}
    </Grid>
  </Container>
);

export default PersonalTrainingInfo;
